<template>
  <div class="tw-rounded tw-border tw-border-light-6 tw-p-6 tw-flex tw-items-center">
    <img :src="meta.favicon" class="tw-rounded tw-w-24 tw-h-24 tw-object-cover" alt="">
    <div class="tw-ml-4">
      <div class="tw-font-bold tw-text-blue tw-text-2xl">{{meta.title}}</div>
      <div class="tw-font-semibold tw-opacity-75 tw-text-2xl">{{meta.description}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      url: {},
    },
    data: v => ({
      meta: {},
      loading: false,
    }),
    watch: {
      url(value) {
        let isValid = this.isValidUrl(value);
        if (isValid) {
          this.refresh()
        }
      }
    },
    methods: {
      isValidUrl(url) {
        try {
          new URL(url);
        } catch (_) {
          return false;
        }

        return true;
      },
      refresh() {
        this.loading = true
        axios.post('/api/v2/url-meta', {url: this.url})
          .then(resp => {
            this.meta = resp.data
          })
          .catch(err => null)
          .finally(() => this.loading = false)
      }
    }
  }
</script>
